import React from 'react';

import {RemoveTriggerAttachment} from 'src/components/remove-trigger-attachment/remove-trigger-attachment';
import {AttachmentMedia} from 'src/components/trigger-attachment/attachment-media';
import {fileAttachmentPreview, fileAttachmentRemoveBtn} from 'src/components/trigger-attachment/trigger-attachment.module.styl';
import {useUserRoles} from 'src/hooks/useUserRoles';
import {Role} from 'src/openapi/models/Role';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';
import {getAttachmentCreationDate} from 'src/utils/getAttachmentCreationDate';

import {Group, Item} from '@pb/kit-component-group';

type Props = {
    eventId: number,
    attachment: TriggerAttachment,
    setFullscreen: (attachment: TriggerAttachment | null) => void,
};

export const AttachmentPreview = (props: Props) => {
    const {
        eventId,
        attachment,
        setFullscreen,
    } = props;

    const userRoles = useUserRoles();

    return (
        <Group direction="v" gap="xxs">
            <Group justify="center" alignItems="center" className={fileAttachmentPreview}>
                <AttachmentMedia
                    isPreview={true}
                    attachment={attachment}
                    setFullscreen={setFullscreen}
                />
                {userRoles.includes(Role.ROLE_UDEDT_ADMIN) && (
                    <Item className={fileAttachmentRemoveBtn}>
                        <RemoveTriggerAttachment eventId={eventId} attachment={attachment}/>
                    </Item>
                )}
            </Group>
            <Group justify="center">
                {getAttachmentCreationDate(attachment)}
            </Group>
        </Group>
    );
};
